/**
 * ShapeCatalog — named polyomino definitions for the Word RPG.
 *
 * Each ShapeDef wraps a framework Shape with game metadata.
 * Start with MONO (single tile); larger polyominoes are defined
 * here and ready to use when the game needs them.
 */

import { Shape } from "../../../framework/geometry";

export interface ShapeDef {
  readonly id: string;
  readonly name: string;
  readonly shape: Shape;
  readonly description: string;
}

// --- Monominoes (1 cell) ---

export const MONO: ShapeDef = {
  id: "mono",
  name: "Single Tile",
  shape: Shape.from([0, 0]),
  description: "A single grid tile",
};

// --- Dominoes (2 cells) ---

export const DOMINO_H: ShapeDef = {
  id: "domino_h",
  name: "Domino (H)",
  shape: Shape.from([0, 0], [0, 1]),
  description: "Two tiles side by side",
};

export const DOMINO_V: ShapeDef = {
  id: "domino_v",
  name: "Domino (V)",
  shape: Shape.from([0, 0], [1, 0]),
  description: "Two tiles stacked",
};

// --- Trominoes (3 cells) ---

export const TROMINO_I: ShapeDef = {
  id: "tromino_i",
  name: "Tromino (I)",
  shape: Shape.from([0, 0], [0, 1], [0, 2]),
  description: "Three tiles in a row",
};

export const TROMINO_L: ShapeDef = {
  id: "tromino_l",
  name: "Tromino (L)",
  shape: Shape.from([0, 0], [1, 0], [1, 1]),
  description: "Three tiles in an L shape",
};

// --- Lookups ---

export const ALL_SHAPES: ShapeDef[] = [
  MONO,
  DOMINO_H, DOMINO_V,
  TROMINO_I, TROMINO_L,
];

export const SHAPES_BY_SIZE: Record<number, ShapeDef[]> = {};
for (const def of ALL_SHAPES) {
  const s = def.shape.size;
  if (!SHAPES_BY_SIZE[s]) SHAPES_BY_SIZE[s] = [];
  SHAPES_BY_SIZE[s].push(def);
}
